import React from "react";

interface FigureProps {
    width?: number | string;
    height?: number | string;
    color?: string;
    className?: string;
}

export const Figure: React.FC<FigureProps> = ({
    width = 125,
    height = 10,
    color = "#555555",
    className
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 125 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M62.5569 9.25429L67.1065 4.70469H124.959V4.4979H67.1065L62.5569 0L58.0591 4.4979H0V4.70469H58.0591L62.5569 9.25429ZM62.5569 0.3102L66.8997 4.60129L62.5569 8.94409L58.2142 4.60129L62.5569 0.3102Z"
                fill={color}
            />
        </svg>
    );
};